/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Lucio API
 * Lucio AI Outlook Add-in Backend API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DeleteNarrativeById200,
  ErrorResponse,
  GetNarrative200,
  GetNarrativeJobs200Item,
  GetNarrativeParams,
  GetNarrativeWalkthrough200,
  PatchNarrativeById200,
  PatchNarrativeByIdBody,
  PatchNarrativeWalkthroughStep200,
  PatchNarrativeWalkthroughStepBody,
  PostNarrativeTrigger200,
  PostNarrativeTriggerBody,
  ValidationErrorResponse
} from '../lucioAPI.schemas';

import { customInstance } from '../../mutator';




/**
 * Retrieve paginated narratives. TODAY/WEEK filter by the rolling UTC window and read the live bucket (no jobId required). CUSTOM requires a jobId and returns the narratives produced by that NarrativeJob. Generation happens asynchronously via POST /trigger; this endpoint never blocks on syncing.
 * @summary Get narratives
 */
export const getNarrative = (
    params: GetNarrativeParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetNarrative200>(
      {url: `/narrative`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetNarrativeQueryKey = (params?: GetNarrativeParams,) => {
    return [
    `/narrative`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetNarrativeQueryOptions = <TData = Awaited<ReturnType<typeof getNarrative>>, TError = ValidationErrorResponse | ErrorResponse>(params: GetNarrativeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNarrative>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNarrativeQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNarrative>>> = ({ signal }) => getNarrative(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNarrative>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNarrativeQueryResult = NonNullable<Awaited<ReturnType<typeof getNarrative>>>
export type GetNarrativeQueryError = ValidationErrorResponse | ErrorResponse


export function useGetNarrative<TData = Awaited<ReturnType<typeof getNarrative>>, TError = ValidationErrorResponse | ErrorResponse>(
 params: GetNarrativeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNarrative>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNarrative>>,
          TError,
          Awaited<ReturnType<typeof getNarrative>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNarrative<TData = Awaited<ReturnType<typeof getNarrative>>, TError = ValidationErrorResponse | ErrorResponse>(
 params: GetNarrativeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNarrative>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNarrative>>,
          TError,
          Awaited<ReturnType<typeof getNarrative>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNarrative<TData = Awaited<ReturnType<typeof getNarrative>>, TError = ValidationErrorResponse | ErrorResponse>(
 params: GetNarrativeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNarrative>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get narratives
 */

export function useGetNarrative<TData = Awaited<ReturnType<typeof getNarrative>>, TError = ValidationErrorResponse | ErrorResponse>(
 params: GetNarrativeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNarrative>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNarrativeQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieve the current walkthrough step and intro-seen state for the user.
 * @summary Get walkthrough state
 */
export const getNarrativeWalkthrough = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetNarrativeWalkthrough200>(
      {url: `/narrative/walkthrough`, method: 'GET', signal
    },
      );
    }
  



export const getGetNarrativeWalkthroughQueryKey = () => {
    return [
    `/narrative/walkthrough`
    ] as const;
    }

    
export const getGetNarrativeWalkthroughQueryOptions = <TData = Awaited<ReturnType<typeof getNarrativeWalkthrough>>, TError = ErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNarrativeWalkthrough>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNarrativeWalkthroughQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNarrativeWalkthrough>>> = ({ signal }) => getNarrativeWalkthrough(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNarrativeWalkthrough>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNarrativeWalkthroughQueryResult = NonNullable<Awaited<ReturnType<typeof getNarrativeWalkthrough>>>
export type GetNarrativeWalkthroughQueryError = ErrorResponse


export function useGetNarrativeWalkthrough<TData = Awaited<ReturnType<typeof getNarrativeWalkthrough>>, TError = ErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNarrativeWalkthrough>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNarrativeWalkthrough>>,
          TError,
          Awaited<ReturnType<typeof getNarrativeWalkthrough>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNarrativeWalkthrough<TData = Awaited<ReturnType<typeof getNarrativeWalkthrough>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNarrativeWalkthrough>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNarrativeWalkthrough>>,
          TError,
          Awaited<ReturnType<typeof getNarrativeWalkthrough>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNarrativeWalkthrough<TData = Awaited<ReturnType<typeof getNarrativeWalkthrough>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNarrativeWalkthrough>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get walkthrough state
 */

export function useGetNarrativeWalkthrough<TData = Awaited<ReturnType<typeof getNarrativeWalkthrough>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNarrativeWalkthrough>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNarrativeWalkthroughQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Set the user to a target walkthrough step (1, 2, or 3). Monotone-only: requests that would move the user backwards are ignored. Marks narrative intro as seen when the user reaches step 3.
 * @summary Advance walkthrough step
 */
export const patchNarrativeWalkthroughStep = (
    patchNarrativeWalkthroughStepBody: PatchNarrativeWalkthroughStepBody,
 ) => {
      
      
      return customInstance<PatchNarrativeWalkthroughStep200>(
      {url: `/narrative/walkthrough/step`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchNarrativeWalkthroughStepBody
    },
      );
    }
  


export const getPatchNarrativeWalkthroughStepMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchNarrativeWalkthroughStep>>, TError,{data: PatchNarrativeWalkthroughStepBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchNarrativeWalkthroughStep>>, TError,{data: PatchNarrativeWalkthroughStepBody}, TContext> => {

const mutationKey = ['patchNarrativeWalkthroughStep'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchNarrativeWalkthroughStep>>, {data: PatchNarrativeWalkthroughStepBody}> = (props) => {
          const {data} = props ?? {};

          return  patchNarrativeWalkthroughStep(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchNarrativeWalkthroughStepMutationResult = NonNullable<Awaited<ReturnType<typeof patchNarrativeWalkthroughStep>>>
    export type PatchNarrativeWalkthroughStepMutationBody = PatchNarrativeWalkthroughStepBody
    export type PatchNarrativeWalkthroughStepMutationError = ErrorResponse

    /**
 * @summary Advance walkthrough step
 */
export const usePatchNarrativeWalkthroughStep = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchNarrativeWalkthroughStep>>, TError,{data: PatchNarrativeWalkthroughStepBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchNarrativeWalkthroughStep>>,
        TError,
        {data: PatchNarrativeWalkthroughStepBody},
        TContext
      > => {

      const mutationOptions = getPatchNarrativeWalkthroughStepMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Trigger narrative generation for a period (TODAY, WEEK, or CUSTOM with date range).
 * @summary Trigger batch narrative generation
 */
export const postNarrativeTrigger = (
    postNarrativeTriggerBody: PostNarrativeTriggerBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostNarrativeTrigger200>(
      {url: `/narrative/trigger`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postNarrativeTriggerBody, signal
    },
      );
    }
  


export const getPostNarrativeTriggerMutationOptions = <TError = ValidationErrorResponse | ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNarrativeTrigger>>, TError,{data: PostNarrativeTriggerBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postNarrativeTrigger>>, TError,{data: PostNarrativeTriggerBody}, TContext> => {

const mutationKey = ['postNarrativeTrigger'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postNarrativeTrigger>>, {data: PostNarrativeTriggerBody}> = (props) => {
          const {data} = props ?? {};

          return  postNarrativeTrigger(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostNarrativeTriggerMutationResult = NonNullable<Awaited<ReturnType<typeof postNarrativeTrigger>>>
    export type PostNarrativeTriggerMutationBody = PostNarrativeTriggerBody
    export type PostNarrativeTriggerMutationError = ValidationErrorResponse | ErrorResponse

    /**
 * @summary Trigger batch narrative generation
 */
export const usePostNarrativeTrigger = <TError = ValidationErrorResponse | ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNarrativeTrigger>>, TError,{data: PostNarrativeTriggerBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postNarrativeTrigger>>,
        TError,
        {data: PostNarrativeTriggerBody},
        TContext
      > => {

      const mutationOptions = getPostNarrativeTriggerMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Retrieve all narrative generation jobs for the current user.
 * @summary List narrative jobs
 */
export const getNarrativeJobs = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetNarrativeJobs200Item[]>(
      {url: `/narrative/jobs`, method: 'GET', signal
    },
      );
    }
  



export const getGetNarrativeJobsQueryKey = () => {
    return [
    `/narrative/jobs`
    ] as const;
    }

    
export const getGetNarrativeJobsQueryOptions = <TData = Awaited<ReturnType<typeof getNarrativeJobs>>, TError = ErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNarrativeJobs>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNarrativeJobsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNarrativeJobs>>> = ({ signal }) => getNarrativeJobs(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNarrativeJobs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNarrativeJobsQueryResult = NonNullable<Awaited<ReturnType<typeof getNarrativeJobs>>>
export type GetNarrativeJobsQueryError = ErrorResponse


export function useGetNarrativeJobs<TData = Awaited<ReturnType<typeof getNarrativeJobs>>, TError = ErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNarrativeJobs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNarrativeJobs>>,
          TError,
          Awaited<ReturnType<typeof getNarrativeJobs>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNarrativeJobs<TData = Awaited<ReturnType<typeof getNarrativeJobs>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNarrativeJobs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNarrativeJobs>>,
          TError,
          Awaited<ReturnType<typeof getNarrativeJobs>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNarrativeJobs<TData = Awaited<ReturnType<typeof getNarrativeJobs>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNarrativeJobs>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List narrative jobs
 */

export function useGetNarrativeJobs<TData = Awaited<ReturnType<typeof getNarrativeJobs>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNarrativeJobs>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNarrativeJobsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update a narrative summary or suppression state.
 * @summary Update a narrative
 */
export const patchNarrativeById = (
    id: string,
    patchNarrativeByIdBody: PatchNarrativeByIdBody,
 ) => {
      
      
      return customInstance<PatchNarrativeById200>(
      {url: `/narrative/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchNarrativeByIdBody
    },
      );
    }
  


export const getPatchNarrativeByIdMutationOptions = <TError = ValidationErrorResponse | ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchNarrativeById>>, TError,{id: string;data: PatchNarrativeByIdBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchNarrativeById>>, TError,{id: string;data: PatchNarrativeByIdBody}, TContext> => {

const mutationKey = ['patchNarrativeById'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchNarrativeById>>, {id: string;data: PatchNarrativeByIdBody}> = (props) => {
          const {id,data} = props ?? {};

          return  patchNarrativeById(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchNarrativeByIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchNarrativeById>>>
    export type PatchNarrativeByIdMutationBody = PatchNarrativeByIdBody
    export type PatchNarrativeByIdMutationError = ValidationErrorResponse | ErrorResponse

    /**
 * @summary Update a narrative
 */
export const usePatchNarrativeById = <TError = ValidationErrorResponse | ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchNarrativeById>>, TError,{id: string;data: PatchNarrativeByIdBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchNarrativeById>>,
        TError,
        {id: string;data: PatchNarrativeByIdBody},
        TContext
      > => {

      const mutationOptions = getPatchNarrativeByIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Soft-delete a narrative by its ID.
 * @summary Delete a narrative
 */
export const deleteNarrativeById = (
    id: string,
 ) => {
      
      
      return customInstance<DeleteNarrativeById200>(
      {url: `/narrative/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteNarrativeByIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteNarrativeById>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteNarrativeById>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteNarrativeById'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteNarrativeById>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteNarrativeById(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteNarrativeByIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteNarrativeById>>>
    
    export type DeleteNarrativeByIdMutationError = ErrorResponse

    /**
 * @summary Delete a narrative
 */
export const useDeleteNarrativeById = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteNarrativeById>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteNarrativeById>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteNarrativeByIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    